define('formkit/behavior/call.registered.view.method.on.press.behavior',['require','exports','module','underscore','marionette','backbone.radio'],function(require, exports, module) {
  var _     = require('underscore');
  var Mn    = require('marionette');
  var Radio = require('backbone.radio');


  var CallRegisteredViewMethodOnPressBehavior = Mn.Behavior.extend({

    defaults: {
      name: null,
      method: null
    },

    getView: function() {
      return Radio.request('viewInstances', this.getOption('name'));
    },

    onPress: function() {
      this.invokeViewMethod();
    },

    invokeViewMethod: function() {
      var view = this.getView();
      var method = this.getOption('method');

      if (view && _.isFunction(view[method])) {
        view[method]({
          callingView: this.view
        })
      }
    }

  });

  module.exports = CallRegisteredViewMethodOnPressBehavior;
});

